import React, { Component } from 'react';
import PropTypes from 'prop-types';
import DatePicker from '../../../containers/date-time-picker/DatePicker';
import moment from 'moment';
import SeatIcon from '../../../icons/SeatIcon';
import FlightsScreenController from '../../../containers/flights/FlightsScreenController';
import Constants from '../../../model/AppConfiguration';
import './DateTimePicker.css';

/**
 * ## Redux imports
 */
import * as allFlightsActions from '../../../redux/actions/AllFlightsActions';
import { Map } from 'immutable';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import selectors from '../../../redux/selectors/Index';

// var allFlights = [
//   {
//     id: '#1234',
//     type: 'AVAILABLE',
//     date: '05/28/2018',
//     text: '37/60',
//     enabled: false,
//     icon: <SeatIcon />,
//   },
//   {
//     id: '#2341',
//     type: 'FULL',
//     date: '04/02/2018',
//     text: '60/60',
//     enabled: false,
//     icon: <SeatIcon />,
//   },
//   {
//     id: '#3412',
//     type: 'AVAILABLE',
//     date: '03/28/2018',
//     text: '12/60',
//     enabled: true,
//     icon: <SeatIcon />,
//   },
//   {
//     id: '#4123',
//     type: 'OFFLINE',
//     date: '04/09/2018',
//     text: '44/60',
//     enabled: false,
//     icon: <SeatIcon />,
//   },
//   {
//     id: '#4312',
//     type: 'FULL',
//     date: '04/13/2018',
//     text: '60/60',
//     enabled: false,
//     icon: <SeatIcon />,
//   },
//   {
//     id: '#4321',
//     type: 'HIGH_DEMAND',
//     date: '04/17/2018',
//     text: '57/60',
//     enabled: true,
//     icon: <SeatIcon />,
//   },
//   {
//     id: '#14312',
//     type: 'AVAILABLE',
//     date: '03/19/2018',
//     text: '07/60',
//     enabled: true,
//     icon: <SeatIcon />,
//   },
// ];
class CalendarDesktop extends Component {
  state = { open: false };

  constructor (props) {
    super(props);

    this.findFlightInfoForSelectedDate(props);

    let allFlights = { flights: [] };
    if (props.allFlights) {
      allFlights = selectors.allFlights.getAllFlightsByRouteId(props.allFlights, props.routeId);
    }
    this.state = { allFlights: allFlights && allFlights.flights ? allFlights.flights : [] };
  }

  // componentWillReceiveProps (props) {
  //   this.findFlightInfoForSelectedDate(props);
  // }

  findFlightInfoForSelectedDate (props) {
    const { selectedDate, selectDate, prefix, flightId, routeId, allFlights } = props;
    if (allFlights) {
      allFlights.find(flights => {
        if (flights.routeId === routeId) {
          if (flights.flights && flights.flights.length) {
            flights.flights.find(flight => {
              if (flight.date === moment(selectedDate).format('MM/DD/YYYY')) {
                selectDate('date', selectedDate, flightId, prefix, flight);
              }
            });
          }
        }
      });
    }
  }

  componentWillReceiveProps (props) {
    const { allFlights, routeId } = props;
    if (
      (allFlights && allFlights.length && allFlights !== this.props.allFlights) ||
      routeId !== this.props.routeId
    ) {
      let flights = selectors.allFlights.getAllFlightsByRouteId(allFlights, routeId);
      this.setState({ allFlights: flights && flights.flights ? flights.flights : [] });
    }
  }

  handleClickOpen = () => {
    this.setState({ open: true });
  };

  handleClose = () => {
    this.setState({ open: false });
  };

  state = {
    date: moment(new Date()),
    viewDate: FlightsScreenController.formatDateLongMonthWithDay(new Date()),
  };

  render () {
    const { selectedDate, selectDate, flightId, prefix } = this.props;
    const { allFlights } = this.state;
    let viewDate = FlightsScreenController.formatDateLongMonthWithDay(selectedDate);
    let minDate = this.props.minDate ?
      moment(this.props.minDate).format(Constants.DATE_FORMAT) :
      '';
    let maxDate = this.props.maxDate ?
      moment(this.props.maxDate).format(Constants.DATE_FORMAT) :
      '';
    return (
      <DatePicker
        className='date-time-picker-always-opened calendar-wrapper'
        spanClassName=''
        readonly
        value={selectedDate}
        viewDate={viewDate}
        showDayText
        locale='en'
        dateFormat={Constants.DATE_FORMAT}
        hideDatePreview
        showInput={false}
        closeOnSelect={false}
        alwaysVisible
        showDayIcon
        minDate={minDate}
        maxDate={maxDate}
        dayRenderingAdditions={allFlights}
        onChange={(e, data) => selectDate('date', e, flightId, prefix, data)}
      />
    );
  }
}

CalendarDesktop.propTypes = {
  selectDate: PropTypes.func,
  routeId: PropTypes.string,
  selectedDate: PropTypes.oneOfType([ PropTypes.string, PropTypes.object ]),
  minDate: PropTypes.oneOfType([ PropTypes.string, PropTypes.object ]),
  maxDate: PropTypes.oneOfType([ PropTypes.string, PropTypes.object ]),
  allFlights: PropTypes.arrayOf(PropTypes.object),
  prefix: PropTypes.string,
  flightId: PropTypes.string,
};

/**
 * ## Redux boilerplate
 */
const actions = [ allFlightsActions ];

function mapStateToProps (state) {
  return {
    isFetching: selectors.global.isFetching(state.global),
    allFlights: selectors.allFlights.getAllFlights(state.allFlights),
  };
}

function mapDispatchToProps (dispatch) {
  const creators = Map()
    .merge(...actions)
    .filter(value => typeof value === 'function')
    .toObject();

  return {
    actions: bindActionCreators(creators, dispatch),
    dispatch,
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(CalendarDesktop);



// WEBPACK FOOTER //
// ./src/components/flights/calendarDesktop/CalendarDesktop.js